<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Información del usuario</h1>
    <div class="information" v-if="user">
      <p v-if="user.first_name" class="information__text"><strong class="information__text--strong">Primer Nombre: </strong>{{user.first_name}}</p>
      <p v-if="user.middle_name" class="information__text"><strong class="information__text--strong">Segundo Nombre: </strong>{{user.middle_name}}</p>
      <p v-if="user.last_name" class="information__text"><strong class="information__text--strong">Apellido: </strong>{{user.last_name}}</p>
      <p v-if="user.second_last_name" class="information__text"><strong class="information__text--strong">Segundo Apellido: </strong>{{user.second_last_name}}</p>
      <p v-if="user.email" class="information__text">
        <strong class="information__text--strong">Correo electrónico: </strong>
        <a :href="'mailto:' + user.email" class="information__text--link" v-text="user.email"></a>
      </p>
      <p v-if="user.phone" class="information__text">
        <strong class="information__text--strong">Teléfono: </strong>
        <a :href="'tel:' + user.phone" class="information__text--link" v-text="user.phone"></a>
      </p>
      <p v-if="user.role_name" class="information__text"><strong class="information__text--strong">Rol de usuario: </strong>{{user.role_name}}</p>
      <p v-if="user.photo" class="information__text"><strong class="information__text--strong">Foto:</strong></p>
      <img v-if="user.photo" :src="cover" :alt="user.first_name" class="information__image">
    </div>
  </div>
</template>

<script>
import {config} from '@/core/config/base'
export default {
  props: {
    user: {
      type: Object
    }
  },
  computed: {
    cover: function () {
      let img = ''
      if (this.user.photo) {
        img = config.statics.url + JSON.parse(this.user.photo).sizes.small
      }
      return img
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/users/view.vue